import React, { useContext, useEffect } from 'react';

import {
    Paper,
    Avatar,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Typography,
    Chip,
    Button,
    Link,
    Tooltip
} from '@material-ui/core';

import {
    ConfirmIconButton
} from '../../../../common';

import { PageContext } from '../PageContext';

import { ApplicationRoles } from '../../../../../helpers';

import PersonIcon from '@material-ui/icons/PersonOutlined'
import CloudIcon from '@material-ui/icons/CloudOutlined';
import DeleteIcon from '@material-ui/icons/Delete'

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        overflow: 'hidden'
    },
    table: {

    },
    user: {
        display: 'flex',
        alignItems: 'center'
    },
    avatar: {
        marginRight: theme.spacing(1)
    }
}));

export const UserList = ({
    disabled,
    onViewUser,
    onRemoveUser,
    ...props }) => {
    const classes = useStyles();

    const {
        state
    } = useContext(PageContext);

    const {
        role
    } = state;

    const {
        users
    } = role;

    const viewUserClickHandler = (user) => {
        if (onViewUser) onViewUser(user);
    }

    const removeUserClickHandler = (user) => {
        if (onRemoveUser) onRemoveUser(user);
    }

    return (
        <Paper className={classes.root}>
            <Table className={classes.table} arial-label="users list">
                <TableHead>
                    <TableRow>
                        <TableCell style={{ width: "90%" }}>Full Name</TableCell>
                        <TableCell align="right"></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {users && users.map((user, index) =>
                        <TableRow hover key={index}>
                            <TableCell component="th" scope="row">
                                <div className={classes.user}>
                                    <Avatar aria-label="avatar" className={classes.avatar}>
                                        <PersonIcon />
                                    </Avatar>
                                    <Link
                                        component="button"
                                        color="textSecondary"
                                        disabled={disabled}
                                        onClick={() => viewUserClickHandler(user)}>
                                        <Typography>
                                            {user.displayName}
                                        </Typography>
                                    </Link>
                                </div>
                            </TableCell>
                            <TableCell align="right">
                                {role.groupAADReference === null ?
                                    <ConfirmIconButton
                                        dangerous
                                        icon={<DeleteIcon />}
                                        tooltip="Revoke this role on all tables"
                                        disabled={disabled}
                                        onClick={() => removeUserClickHandler(user)}
                                    />
                                    :
                                    <Tooltip title="Role configured by group membership in Active Directory">
                                        <Chip
                                            icon={<CloudIcon />}
                                            label="Active Directory"
                                            variant="outlined"
                                        />
                                    </Tooltip>
                                }
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </Paper>
    );
}